import React from "react";
import { BrowserRouter, Route, Switch } from "react-router-dom";
import App from "../App";
import SuccessView from "../views/successView";
const RootView = React.lazy(() => import("../views/rootView"));

const AppRoutes = () => (
    <App>
        <BrowserRouter>
            <Route
                render={() => (
                    <Switch>
                        <Route exact path="/" component={RootView} />
                        <Route exact path="/success" component={SuccessView} />
                        <Route exact path="/:id" component={RootView} />
                    </Switch>
                )}
            />
        </BrowserRouter>
    </App>
);

export default AppRoutes;
